module.exports = __webpack_public_path__ + "img/create-wallet-zh.a996e98e.png";